import { merge as objectMapper } from 'object-mapper';

import type { GetCustomerCreditorsParams } from 'api';

import type { LocalState } from './localState';

type Params = LocalState;

export const apiParams = function (params: Params): GetCustomerCreditorsParams {
  const filteredParams: Params = {
    ...params
  };

  const map = {
    sort: 'sort',
    cursorPrev: 'cursor_prev',
    cursorNext: 'cursor_next'
  };
  return objectMapper(filteredParams, map) as GetCustomerCreditorsParams;
};
